import { Notification as NotificationRA } from 'react-admin';

const Notification = props => <NotificationRA style={{color: 'white', backgroundColor: 'rgb(240, 240, 240)'}} {...props} autoHideDuration={5000}  />;

export default Notification;